import { types as coreTypes } from '@sitebuilder/core';

const schema: coreTypes.Schema = {
    enableGrouping: {
        title: 'Enable Grouping',
        type: 'boolean',
        default: false,
    },
};

const dependencies: coreTypes.Schema = {
    enableGrouping: {
        oneOf: [
            {
                properties: {
                    enableGrouping: { enum: [true] },
                    groupingPropertyId: {
                        type: 'string',
                        title: 'Enter filter id for grouping',
                        default: '',
                    },
                    showGroupingCount: {
                        type: 'boolean',
                        title: 'Is show grouping count',
                        default: false,
                    },
                    isCollapseRowGroup: {
                        type: 'boolean',
                        title: 'Is Collapse row group',
                        default: false,
                    },
                },
            },
            {
                properties: {
                    enableGrouping: { enum: [false] },
                },
            },
        ],
    },
    isCollapseRowGroup: {
        oneOf: [
            {
                properties: {
                    isCollapseRowGroup: { enum: [true] },
                    showRowGroupIconName: {
                        type: 'string',
                        title: 'Show row group icon name',
                        default: '',
                    },
                    hideRowGroupIconName: {
                        type: 'string',
                        title: 'Hide row group icon name',
                        default: '',
                    },
                },
            },
            {
                properties: {
                    isCollapseRowGroup: { enum: [false] },
                },
            },
        ],
    },
};

const uiSchema = {
    enableGrouping: { 'ui:widget': 'CustomCheckbox' },
    groupingPropertyId: { 'ui:widget': 'CustomTextInput' },
    showGroupingCount: { 'ui:widget': 'CustomCheckbox' },
    isCollapseRowGroup: { 'ui:widget': 'CustomCheckbox' },
    showRowGroupIconName: { 'ui:widget': 'CustomTextInput' },
    hideRowGroupIconName: { 'ui:widget': 'CustomTextInput' },
};

const rowGroupSchema = {
    schema,
    uiSchema,
    dependencies,
};

export default rowGroupSchema;
